import { validateLatitudeLongitude } from '@deckee/utilities';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectUserChoices } from '../../../../services/store/modules/incident-report';

const useIncidentReportingLocation = (onError = () => {}) => {
  const { latitude: selectedLatitude, longitude: selectedLongitude } =
    useSelector(selectUserChoices);

  const errorCallback = useRef();

  // Update the reference for on error callback - we don't want to pass this into the second use effect directly to avoid calling
  // validate too often
  useEffect(() => {
    errorCallback.current = onError;
  }, [onError]);

  useEffect(() => {
    if (!validateLatitudeLongitude(selectedLatitude, selectedLongitude)) {
      errorCallback.current();
    }
  }, [selectedLatitude, selectedLongitude]);

  return [selectedLatitude, selectedLongitude];
};

export default useIncidentReportingLocation;
